import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdGamepad,
  MdSafetyCheck,
  MdCreate,
  MdGames,
  MdLocalActivity,
} from 'react-icons/md';
// Admin Imports
import Dashboards from 'views/admin/dashboards/rtl/index';
import SuperAdminCompany from 'views/admin/superadmin/company/index';
import SuperAdminPlan from 'views/admin/superadmin/plan/index';
import SuperAdminIndustry from 'views/admin/superadmin/industry/index';
// vb 02.01.2024
import SuperAdminCategory from 'views/admin/superadmin/category/index';
// vb 02.01.2024
import SuperAdminCreator from 'views/admin/superadmin/creator/index';
import Learner from 'views/admin/superadmin/learner';
import Game from 'views/admin/superadmin/game/index';
import { IoBuild } from 'react-icons/io5';
// import { FaBuilding } from "react-icons/fa6";
import { FaBuildingColumns } from 'react-icons/fa6';
import { GiClassicalKnowledge } from 'react-icons/gi';
import { VscGroupByRefType } from 'react-icons/vsc';
import ProfileSetting from 'views/admin/creator/settings/index';
import Chortors from 'views/admin/superadmin/Cohort/index';
import SuperAdminCreatorActivity from 'views/admin/superadmin/creatorActivity/index';
import GameWiseActivity from 'views/admin/superadmin/gamewise_activity/index';
import LearnerActivity from 'views/admin/superadmin/learner_activity/index';
import AssessmentActivity from 'views/admin/superadmin/AssessmentAnalytics/index'
import CertificationActivity from 'views/admin/superadmin/Certification/index'
import QuestActivity from 'views/admin/superadmin/QuestAnalytics/index'
import { TbBrandGoogleAnalytics } from 'react-icons/tb';
import { PiStudentDuotone } from 'react-icons/pi';
import { TbBusinessplan } from 'react-icons/tb';
import { LiaIndustrySolid } from 'react-icons/lia';
import { MdOutlineCategory } from 'react-icons/md';
import { FaChalkboardTeacher } from 'react-icons/fa';
import { RiUserSettingsLine } from 'react-icons/ri';

const storage = JSON.parse(localStorage.getItem('user'));
let role = '';
if (!storage) {
  role = 'Admin';
} else {
  role = storage.data.role;
}
const isAdmin = role === 'Admin';
const isCreator = role === 'Creator';

const id = storage?.data?.id;
console.log(id,'idintabs')
const routes = [
  //  {
  //     name: 'Dashboard',
  //     layout: '/admin',
  //     path: '/dashboards',
  //     icon: ( <Icon as={MdHome} width="20px" height="20px" color="#ffffff" /> ),
  //     component: <Dashboards />,
  //   },
  isAdmin && {
    name: 'Company',
    path: '/superadmin/customer',
    layout: '/admin',
    icon: (
      <Icon as={FaBuildingColumns} width="17px" height="17px" color="#ffffff" />
    ),
    component: <SuperAdminCompany />,
    items: [
      role === 'Admin' && {
        name: 'Company',
        layout: '/admin',
        path: '/superadmin/customer',
        component: <SuperAdminCompany />,
        secondary: true,
        protected: true,
      },
    ].filter(Boolean),
  },

  isAdmin && {
    name: `Plan`,
    path: '/superadmin/plan',
    layout: '/admin',
    icon: (
      <Icon as={TbBusinessplan} width="20px" height="20px" color="#ffffff" />
    ),
    component: <SuperAdminPlan />,
    secondary: true,
    protected: true,
  },
  isAdmin && {
    name: 'Industry',
    path: '/superadmin/industry',
    layout: '/admin',
    icon: (
      <Icon as={LiaIndustrySolid} width="20px" height="20px" color="#ffffff" />
    ),
    component: <SuperAdminIndustry />,
    secondary: true,
    protected: true,
  },
  // vb 02.01.2024
  isAdmin && {
    name: 'Category',
    path: '/superadmin/category',
    layout: '/admin',
    icon: (
      <Icon as={MdOutlineCategory} width="20px" height="20px" color="#ffffff" />
    ),
    component: <SuperAdminCategory />,
    secondary: true,
    protected: true,
  },
  isCreator &&{
    name: 'Games',
    path: '/superadmin/game',
    layout: '/admin',
    icon: <Icon as={MdGamepad} width="20px" height="20px" color="#ffffff" />,
    component: <Game />,
    secondary: true,
    protected: true,
  },
  {
    name: 'Learner',
    path: '/superadmin/learner',
    layout: '/admin',
    icon: (
      <Icon as={PiStudentDuotone} width="20px" height="20px" color="#ffffff" />
    ),
    component: <Learner />,
    secondary: true,
    protected: true,
  },
  {
    name: 'Cohorts',
    path: '/superadmin/cohort',
    layout: '/admin',
    icon: (
      <Icon as={VscGroupByRefType} width="20px" height="20px" color="#ffffff" />
    ),
    component: <Chortors />,
    secondary: true,
    protected: true,
  },
  // vb 02.01.2024
  isAdmin && {
    name: 'Creator',
    path: '/superadmin/creator',
    layout: '/admin',
    icon: (
      <Icon
        as={FaChalkboardTeacher}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <SuperAdminCreator />,
    secondary: true,
    protected: true,
  },

  isAdmin && {
    name: 'Creator Analytics',
    path: '/superadmin/Creator_activity',
    layout: '/admin',
    icon: (
      <Icon
        as={TbBrandGoogleAnalytics}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <SuperAdminCreatorActivity />,
    secondary: true,
    protected: true,
  },

  {
    name: 'Learner Analytics',
    path: '/superadmin/Learner_activity',
    layout: '/admin',
    icon: (
      <Icon
        as={TbBrandGoogleAnalytics}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <LearnerActivity />,
    secondary: true,
    protected: true,
  },
  {
    name: 'Assessment Analytics',
    path: '/superadmin/AssessmentAnalytics',
    layout: '/admin',
    icon: (
      <Icon
        as={TbBrandGoogleAnalytics}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <AssessmentActivity />,
    secondary: true,
    protected: true,
  },
  {
    name: 'Certification Analytics',
    path: '/superadmin/Certification',
    layout: '/admin',
    icon: (
      <Icon
        as={TbBrandGoogleAnalytics}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <CertificationActivity />,
    secondary: true,
    protected: true,
  },
  {
    name: 'Quest Analytics',
    path: '/superadmin/QuestAnalytics',
    layout: '/admin',
    icon: (
      <Icon
        as={TbBrandGoogleAnalytics}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <QuestActivity />,
    secondary: true,
    protected: true,
  },

  // {
  //   name: 'Game Analytics ',
  //   path: '/superadmin/gamewise_activity',
  //   layout: '/admin',
  //   icon: (
  //     <Icon
  //       as={TbBrandGoogleAnalytics}
  //       width="20px"
  //       height="20px"
  //       color="#ffffff"
  //     />
  //   ),
  //   component: <GameWiseActivity />,
  //   secondary: true,
  //   protected: true,
  // },

  isCreator && {
    name: 'Profile Settings',
    path: `/creator/settings/${id}`,
    layout: '/admin',
    icon: (
      <Icon
        as={RiUserSettingsLine}
        width="20px"
        height="20px"
        color="#ffffff"
      />
    ),
    component: <ProfileSetting />,
    secondary: true,
    protected: true,
  },
].filter(Boolean);

export default routes;
